// import React, {PropsWithChildren} from 'react';

// import {View, SafeAreaView, TouchableOpacity} from 'react-native';
// import RNModal from 'react-native-modal';

// import {colors} from 'asset/constant';
// import {styles} from 'component/picker/styles';
// import ModalBar from 'component/modal/ModalBar';

// type PropsT = {visible?: boolean; hide?: () => void; fitHeight?: boolean};

// export default function Modal(props: PropsWithChildren<PropsT>) {
//   const {hide, visible, fitHeight} = props;

//   return (
//     <RNModal
//       isVisible={visible}
//       style={styles.modal}
//       animationInTiming={0}
//       animationOutTiming={0}
//       onBackButtonPress={hide}
//       animationIn="slideInUp"
//       animationOut="slideOutDown">
//       <SafeAreaView style={styles.modalContainer}>
//         <TouchableOpacity
//           activeOpacity={1}
//           onPress={hide}
//           style={styles.topGap}
//         />
//         <View
//           style={{
//             ...styles.listContainer,
//             ...(fitHeight && {height: '100%'}),
//             shadowColor: colors.text.normal,
//           }}>
//           <ModalBar />
//           {props?.children}
//         </View>
//       </SafeAreaView>
//     </RNModal>
//   );
// }

import React, { PropsWithChildren } from "react";
import {
  View,
  ViewStyle,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import ReactNativeModal from "react-native-modal";
import Toast from "component/toast";

import { sn } from "utils";
import { sizes, colors } from "asset/constant";
import Button from "component/button/Button";

type ModalT = {
  visible?: boolean;
  close?: () => void;
  hideToast?: boolean;
  hideCloseBtn?: boolean;
  contentContainerStyle?: ViewStyle;
  disableCloseWithOutsideTap?: boolean;
  disableCloseWithBakButtonTap?: boolean;
  onShow?: () => void;
};

const Modal: React.FC<PropsWithChildren<ModalT>> = ({
  close,
  visible,
  children,
  hideToast,
  hideCloseBtn,
  contentContainerStyle,
  disableCloseWithOutsideTap,
  disableCloseWithBakButtonTap,
  onShow,
}) => {
  return (
    <ReactNativeModal
      onShow={onShow}
      isVisible={visible}
      style={{ margin: 0 }}
      animationIn={"slideInUp"}
      animationOut={"slideOutDown"}
      onBackButtonPress={!disableCloseWithBakButtonTap ? close : null}
    >
      <TouchableOpacity
        activeOpacity={1}
        style={styles.cover}
        onPress={!disableCloseWithOutsideTap ? close : null}
      >
        <View style={styles.container}>
          <ScrollView
            nestedScrollEnabled
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps={"handled"}
            contentContainerStyle={styles.scroll}
          >
            <TouchableOpacity
              activeOpacity={1}
              style={styles.scroll}
              onPress={!disableCloseWithBakButtonTap ? close : null}
            >
              <TouchableOpacity
                activeOpacity={1}
                onPress={null}
                style={{ ...styles.contentContainer, ...contentContainerStyle }}
              >
                {!hideCloseBtn && (
                  <View
                    style={{
                      top: 0,
                      left: 0,
                      width: 45,
                      height: 45,
                      zIndex: 1000,
                      position: "absolute",
                    }}
                  >
                    <Button
                      onPress={close}
                      square={45}
                      bgColor={colors.transparent}
                      icon={{
                        type: "feather",
                        name: "x",
                        color: colors.danger,
                        size: 25,
                      }}
                    />
                  </View>
                )}
                {children}
              </TouchableOpacity>
            </TouchableOpacity>
          </ScrollView>
        </View>
      </TouchableOpacity>
      {!hideToast && <Toast.Provider />}
    </ReactNativeModal>
  );
};

export default React.memo(Modal);

const styles = StyleSheet.create({
  cover: { flex: 1, alignItems: "center" },

  container: {
    flex: 1,
    marginTop: sn(50, 50, 20, 20),
    marginBottom: sn(0, 0, 20, 20),
    width: "100%",
    maxWidth: 640,
    overflow: "hidden",
    borderRadius: sn(0, 0, sizes.radius.lg, sizes.radius.lg),
    borderTopLeftRadius: sizes.radius.lg,
    borderTopRightRadius: sizes.radius.lg,
  },

  scroll: {
    flexGrow: 1,
    maxWidth: 640,
    overflow: "hidden",
    backgroundColor: "transparent",
    borderTopLeftRadius: sizes.radius.lg,
    borderTopRightRadius: sizes.radius.lg,
    justifyContent: sn("flex-end", "flex-end", "center", "center"),
  },

  contentContainer: {
    paddingTop: 40,
    paddingBottom: 20,
    width: "100%",
    maxWidth: 640,
    paddingHorizontal: 2 * sizes.space,
    backgroundColor: colors.white,
    borderTopLeftRadius: sizes.radius.lg,
    borderTopRightRadius: sizes.radius.lg,
    alignSelf: "center",
    borderBottomLeftRadius: sn(0, 0, sizes.radius.lg, sizes.radius.lg),
    borderBottomRightRadius: sn(0, 0, sizes.radius.lg, sizes.radius.lg),
    overflow: "hidden",
  },
});
